<template>
  <table class="participantes-products">
    <thead>
      <tr>
        <th class="product-header">
          Nome
        </th>
        <th class="product-header">
          KPI
        </th>
        <th class="product-header">
          {{ isComercial ? 'Escoamento/Quantidade' : 'Escoamento informado' }}
        </th>
        <th
          v-if="hasTotalAcceleratorSDZ && isComercial"
          class="product-header"
        >
          Total acelerador
        </th>
        <th class="product-header">
          Total SDZ
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="product in products"
        :key="product._id"
      >
        <td class="product-details">
          {{ product.name }}
        </td>
        <td class="product-details">
          {{ product.kpi || '-' }}
        </td>
        <td class="product-details">
          {{ product.sellOut || '-' }}
        </td>
        <td
          v-if="hasTotalAcceleratorSDZ && isComercial"
          class="product-details"
        >
          {{ product.totalAcceleratorSeedz }}
        </td>
        <td class="product-details">
          {{ product.totalSeedz }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'ParticipantsProducts',
  props: {
    products: {
      type: Array,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    hasTotalAcceleratorSDZ: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isComercial() {
      return this.role === 'comercial'
    }
  }
}
</script>
<style lang="stylus" scoped>
  .participantes-products
    background-color #FAFAFA
    padding 0 16px
    width 100%

    .product-header
      color #1E7A75
      font-weight 600
      text-align left

    .product-details
      height auto
      padding 8px 24px

</style>
